module.exports = __webpack_public_path__ + "assets/98eda29b830338a4ec48ddf158dfb2e0.jpg";